__turbopack_context__.v({
  "inStorePromoMessage": "InStorePromoMessage-module-scss-module__AjALfa__inStorePromoMessage",
});
